<template>
  <!-- Section 1 -->
  <div class="split-title image-fade-in">
    <div class="title-top">Livracourse</div>
    <div class="hr-gold" role="separator" aria-label="Séparateur"></div>
    <div class="title-bottom"><strong>Express</strong></div>
  </div>
  <section class="about-livratos-section">
    <div class="container">
      <!-- Bloc 1 : Fonctionnement général EXPRESS -->
      <div class="about-row">
        <div class="about-image">
          <img
            src="@/assets/pictures/livraison-express-1.webp"
            alt="Livraison express depuis les dépôts vers les chantiers"
            class="img-fluid"
          />
        </div>

        <div class="about-text">
          <h2>
            <strong class="gold">Livraison Express</strong><br />
            L’approvisionnement immédiat, pour tous les acteurs du BTP
          </h2>

          <p>
            Une <strong>urgence sur chantier</strong>, un client pro qui attend,
            ou une commande à remettre en mouvement&nbsp;? La
            <strong>livraison express</strong> Livratos déclenche
            automatiquement la prise en charge&nbsp;: le système identifie le
            <strong>livreur disponible</strong> le plus proche, sélectionne un
            véhicule adapté et lance la course en quelques secondes. Tout est
            pensé pour acheminer un produit
            <strong>le plus vite possible</strong> entre un dépôt, un
            <strong>chantier</strong>
            ou un client final.
          </p>

          <p>
            Ce fonctionnement instantané simplifie la vie de tout
            l’écosystème&nbsp;: le <strong>fournisseur</strong> évite les files
            d’attente et fluidifie son dépôt, l’<strong>artisan</strong> reçoit
            ce dont il a besoin sans interrompre son avancement, et le
            <strong>livreur</strong> bénéficie de missions claires, rapides et
            mieux organisées. Chacun gagne en efficacité, sans effort
            supplémentaire.
          </p>
        </div>
      </div>

      <!-- Bloc 2 : Valeur business EXPRESS (inversé) -->
      <div class="about-row reverse">
        <div class="about-image bg-dark">
          <img
            src="@/assets/pictures/livraison-express-2.webp"
            alt="Artisans qui gagnent du temps grâce à la livraison express"
            class="img-fluid"
          />
        </div>

        <div class="about-text">
          <h2>
            <strong class="gold">Un vrai gain</strong><br />
            pour les fournisseurs, artisans et livreurs
          </h2>

          <p>
            Pour les <strong>fournisseurs</strong>, l’Express devient un service
            premium immédiat&nbsp;: une course déclenchée depuis le comptoir
            accélère le flux, réduit les attentes et améliore l’expérience des
            clients pros. L’<strong>artisan</strong>, lui, garde ses équipes sur
            place et sécurise la continuité du <strong>chantier</strong>. Quant
            aux <strong>livreurs</strong>, ils profitent de trajets courts,
            précis et rentables, optimisés par un dispatch intelligent.
          </p>

          <p>
            Au final, la <strong>livraison express</strong> crée un cercle
            vertueux&nbsp;:
            <strong
              >des dépôts plus fluides, des <strong>chantiers</strong> qui
              avancent, des <strong>livreurs</strong> mieux utilisés</strong
            >. Une seule action, un bénéfice immédiat pour tout le réseau.
          </p>
        </div>
      </div>
    </div>
  </section>

  <div class="split-title image-fade-in">
    <div class="title-top">Livracourse</div>
    <div class="hr-gold" role="separator" aria-label="Séparateur"></div>
    <div class="title-bottom"><strong>Programmée</strong></div>
  </div>

  <!-- Section 2 -->
  <section class="about-livratos-section">
    <div class="container">
      <!-- Bloc 3 : Livreurs -->
      <div class="about-row">
        <div class="about-image">
          <img
            src="@/assets/pictures/route-livraison.webp"
            alt="Livreur indépendant spécialisé dans le BTP"
            class="img-fluid"
          />
        </div>
        <div class="about-text">
          <h2>
            <strong class="gold">Livraisons programmées</strong><br />
            Planifiées, multi-étapes, toujours sous contrôle
          </h2>

          <p>
            Pour les trajets qui s’organisent à l’avance — qu’ils soient
            simples, d’un point A à B, ou complets, d’un point A jusqu’au point
            Z — Livratos gère toute la logique de la
            <strong>livraison programmée</strong>. Le système calcule
            automatiquement le meilleur itinéraire, anticipe les étapes de
            chargement et de déchargement, et planifie l’arrivée du chauffeur à
            l’heure prévue au dépôt.
          </p>

          <p>
            Vous pouvez intégrer des rechargements intermédiaires,
            <strong>livrer plusieurs chantiers</strong> dans un seul trajet, ou
            organiser une <strong>tournée complète avec un seul camion</strong>.
            Tout est orchestré pour que la
            <strong>livraison longue distance</strong> soit fluide, structurée
            et parfaitement maîtrisée du début à la fin.
          </p>
        </div>
      </div>

      <!-- Bloc 4 : Dernier kilomètre (inversé) -->
      <div class="about-row reverse">
        <div class="about-image bg-dark">
          <img
            src="@/assets/pictures/livraison-programee-2.webp"
            alt="Pilotage du dernier kilomètre pour les livraisons BTP"
            class="img-fluid"
          />
        </div>
        <div class="about-text">
          <h2>
            <strong class="gold">Une planification fiable</strong><br />
            pour les fournisseurs, artisans et livreurs
          </h2>

          <p>
            Livratos prend en compte la réglementation européenne du temps de
            conduite&nbsp;: pauses obligatoires, limites horaires, nuits légales
            et fenêtres de repos. La plateforme calcule automatiquement les
            temps d’arrêt à prévoir, garantit un trajet conforme et sécurise
            toute la chaîne de transport.
          </p>

          <p>
            Pour les <strong>fournisseurs</strong>, cela signifie un chauffeur
            qui se présente à l’heure exacte prévue pour charger. Pour les
            <strong>artisans</strong>, la certitude de recevoir les matériaux au
            moment planifié, même sur des <strong>chantiers éloignés</strong>.
            Et pour les <strong>livreurs</strong>, des tournées plus longues,
            mieux organisées et mieux rémunérées, sans stress administratif. Une
            logistique programmée qui apporte stabilité et performance à tous.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosAboutSections",
};
</script>

<style lang="scss" scoped>
.about-livratos-section {
  background-color: $background;
  padding: 80px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 80px;
  }

  .about-row {
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;

    @media (min-width: 992px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      gap: 60px;
    }

    &.reverse {
      @media (min-width: 992px) {
        flex-direction: row-reverse;
      }
    }

    .about-image {
      background-color: $color-primary;
      border-radius: 15px;
      padding: 10px;
      img {
        width: 100%;
        max-width: 520px;
        border-radius: 12px;
        object-fit: cover;
        //box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      }
    }

    .about-text {
      flex: 1;
      max-width: 520px;

      h2 {
        font-size: 1.75rem;
        font-weight: 700;
        color: $color-text;
        line-height: 1.3;

        @media (min-width: 768px) {
          font-size: 2.25rem;
        }
      }

      p {
        margin-top: 1rem;
        font-size: 1rem;
        color: $color-text-grey;
        line-height: 1.7;
        text-align: justify;

        @media (min-width: 768px) {
          font-size: 1.125rem;
        }
      }
    }
  }
}

.hr-gold {
  width: min(1120px, calc(100% - 40px));
  margin: 16px auto;
  height: 8px;
  border-radius: 999px;
  background: #000; // barre noire
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.6) inset, 0 6px 14px rgba(0, 0, 0, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.18) inset;
  position: relative;
  overflow: hidden;

  @media (min-width: 768px) {
    margin: 16px auto;
  }
}

.hr-gold::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32%; // largeur du faisceau
  left: 0;
  background: radial-gradient(
    circle at 50% 50%,
    rgba($color-primary, 0.95),
    rgba($color-primary, 0.25) 60%,
    transparent 80%
  );
  box-shadow: 0 0 12px rgba($color-primary, 0.9),
    0 0 24px rgba($color-primary, 0.7);
  animation: livratos-beam 2.4s ease-in-out infinite alternate;
  pointer-events: none;
}

@keyframes livratos-beam {
  0% {
    left: -10%;
  }
  100% {
    left: 81%; // 100% - 22% => le faisceau ne sort jamais de la barre
  }
}

.split-title {
  width: min(1120px, calc(100% - 40px));
  margin: 44px auto 50px;
  text-align: center;
  @media (min-width: 768px) {
    margin: 100px auto 80px;
  }
}

.title-top {
  color: $color-primary;
  font-weight: 900;
  letter-spacing: 0.04em;
  font-size: clamp(1.8rem, 6vw, 2.5rem);
  line-height: 1.05;
  margin-bottom: 14px;
  text-transform: uppercase;
}

.title-bottom {
  color: $color-text;
  font-weight: 900;
  letter-spacing: 0.03em;
  font-size: clamp(1.4rem, 5vw, 2rem);
  line-height: 1.05;
  margin-top: 14px;
  text-transform: uppercase;

  strong {
    font-weight: 900 !important;
  }
}
.gold {
  color: $color-primary;
}
</style>
